import styled from 'styled-components';

import FlexRow from '../ui/FlexRow';

const AvailableRow = styled(FlexRow)`
  height: 100%;
  background-color: #d7e8db;
`;

export default AvailableRow;
